import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import PageHeader from "@/pages/_shared/PageHeader";
import { Link } from "react-router-dom";
import { FadeUp, Stagger, StaggerItem, SlideUpLine } from "@/pages/_shared/anim";
import RequestinstallationConsultation from "../../../src/assets/Solutions1.jpg";
import GetTechincalsupport from "../../../src/assets/Solutions2.jpg";
import PCRrepair from "../../../src/assets/Solutions3.jpg";
import TestingSupport from "../../../src/assets/Solutions4.jpg";
import DiscussRequirement from "../../../src/assets/Solutions5.jpg";
import ProgrammingSupport from "../../../src/assets/Solutions6.jpg";
import RequestSurvey from "../../../src/assets/Solutions7.jpg";
import RequestInseption from "../../../src/assets/Solutions8.jpg";
import Discussonupgrade from "../../../src/assets/Solutions9.jpg";

const services = [
  {
    code: "01",
    title: "Supply & Installation",
    summary:
      "Complete elevator supply and installation solutions for residential, commercial, healthcare, hospitality, and industrial requirements.",
    items: [
      "Home Elevators",
      "Passenger Elevators",
      "Cargo Elevators",
      "Bed Elevators",
      "Panoramic Elevators",
      "Kitchen Elevators",
    ],
    cta: "REQUEST INSTALLATION CONSULTATION",
    image: RequestinstallationConsultation,
  },
  {
    code: "02",
    title: "Technical Solutions",
    summary:
      "Professional technical assistance for elevators and escalators covering troubleshooting, diagnosis, system support, and specialized technical requirements.",
    items: [
      "System troubleshooting and diagnosis",
      "Technical consultation and advice",
      "System performance evaluation",
      "Alternative technical approaches",
      "Multi-brand system support",
    ],
    cta: "GET TECHNICAL SUPPORT",
    image: GetTechincalsupport
  },
  {
    code: "03",
    title: "PCB Repair",
    summary:
      "All-brand PCB repair support covering single-layer, double-layer, and multilayer PCBs — an important specialized capability.",
    items: [
      "Single-Layer PCB repair",
      "Double-Layer PCB repair",
      "Multilayer PCB repair",
      "Component-level diagnostics",
      "Multi-brand board support",
    ],
    cta: "REQUEST PCB REPAIR",
    image: PCRrepair,
  },
  {
    code: "04",
    title: "Testing & Commissioning",
    summary:
      "Technical testing and commissioning services for elevators and escalators to support correct system operation and readiness.",
    items: [
      "System functional testing",
      "Performance verification",
      "Commissioning support",
      "Operational readiness checks",
      "Documentation and reporting",
    ],
    cta: "REQUEST TESTING SUPPORT",
    image: TestingSupport,
  },
  {
    code: "05",
    title: "Alternative Design & Ideas",
    summary:
      "Alternative elevator design and technical solutions considering configurations with or without machine rooms.",
    items: [
      "With Machine Room solutions",
      "Without Machine Room solutions",
      "Space optimization designs",
      "Technical feasibility assessment",
      "Alternative component recommendations",
    ],
    cta: "DISCUSS YOUR REQUIREMENT",
    image: DiscussRequirement
  },
  {
    code: "06",
    title: "Programming & Configurations",
    summary:
      "Technical programming and configuration support for compatible elevator and escalator systems and control equipment.",
    items: [
      "Controller programming",
      "System configuration",
      "Parameter optimization",
      "Drive configuration",
      "Control system support",
    ],
    cta: "GET PROGRAMMING SUPPORT",
    image: ProgrammingSupport
  },
  {
    code: "07",
    title: "Conditional Surveys & Advice",
    summary:
      "Professional condition assessment and technical advice to help customers understand system status and identify suitable next steps.",
    items: [
      "System condition evaluation",
      "Component inspection",
      "Technical recommendations",
      "Upgrade and repair advice",
      "Maintenance planning input",
    ],
    cta: "REQUEST A SURVEY",
    image: RequestSurvey
  },
  {
    code: "08",
    title: "Safety Inspection & Reporting",
    summary:
      "Elevator and escalator safety inspection services supported by structured reporting and technical recommendations.",
    items: [
      "Safety system inspection",
      "Compliance checks",
      "Structured reporting",
      "Technical recommendations",
      "Follow-up support",
    ],
    cta: "REQUEST AN INSPECTION",
    image: RequestInseption
  },
  {
    code: "09",
    title: "Maintenance & Upgradation",
    summary:
      "Maintenance and modernization support designed to improve system performance, reliability, safety, and operational life.",
    items: [
      "Preventive maintenance support",
      "System modernization",
      "Performance improvement",
      "Reliability enhancement",
      "Component upgradation",
    ],
    cta: "DISCUSS AN UPGRADE",
    image: Discussonupgrade
  },
];

const comparison = [
  {
    need: "Spare Part Supply",
    bestFor: "Replacement component",
    action: "Request Part",
  },
  {
    need: "PCB Repair",
    bestFor: "Faulty electronic board",
    action: "Send PCB Details",
  },
  {
    need: "Technical Support",
    bestFor: "Complex technical issue",
    action: "Talk to Technical Team",
  },
  {
    need: "System Upgrade",
    bestFor: "Aging system",
    action: "Request Assessment",
  },
  {
    need: "Complete Installation",
    bestFor: "New elevator requirement",
    action: "Discuss Installation",
  },
];

export default function SolutionsPage() {
  return (
    <div className="min-w-0 bg-crest-cream">
      <Navbar />
      <main>
        <PageHeader
          eyebrow="Services & capabilities"
          title={
            <>
              Complete Support for
              <br />
              <span className="text-white">Elevators & Escalators.</span>
            </>
          }
          description="From installation to technical troubleshooting, Uplift One provides specialized services across the complete elevator and escalator lifecycle."
          crumbs={[
            { label: "Home", to: "/" },
            { label: "Solutions" },
          ]}
          meta={[
            { label: "Service areas", value: "9" },
            { label: "PCB layers", value: "All" },
            { label: "Brand support", value: "Multi" },
            { label: "Coverage", value: "UAE" },
          ]}
        />

        {/* Service detail rows */}
        <section className="bg-crest-cream py-16 md:py-20">
          <div className="px-6 md:px-12 space-y-10">
            {services.map((s, i) => (
              <FadeUp key={s.code} y={40}>
                <article
                  className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 bg-white rounded-xl overflow-hidden border border-black/5"
                >
                  <div className="lg:col-span-7 p-7 md:p-10">
                    <div className="flex items-center gap-3 text-crest-bg/80 text-xs font-semibold tracking-widest">
                      <span>{s.code}</span>
                      <span className="w-6 h-px bg-crest-deep/30" />
                      <span>SERVICE</span>
                    </div>
                    <h2 className="font-display text-3xl md:text-4xl text-crest-deep mt-3 leading-tight">
                      <SlideUpLine as="div">{s.title}</SlideUpLine>
                    </h2>
                    <p className="text-crest-deep/75 text-base mt-3 leading-relaxed">
                      {s.summary}
                    </p>

                    <Stagger className="mt-6 space-y-2.5" stagger={0.06}>
                      {s.items.map((m) => (
                        <StaggerItem
                          key={m}
                          className="flex items-start gap-3 text-sm text-crest-deep/80"
                        >
                          <span className="w-5 h-5 flex items-center justify-center rounded-full bg-crest-orange text-white shrink-0 mt-0.5">
                            <i className="ri-check-line text-xs"></i>
                          </span>
                          {m}
                        </StaggerItem>
                      ))}
                    </Stagger>

                    <div className="mt-7 pt-5 border-t border-black/5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                      <Link
                        to="/contact"
                        className="inline-flex items-center gap-2 text-crest-deep font-semibold text-sm cursor-pointer whitespace-nowrap hover:text-crest-bg"
                      >
                        {s.cta}
                        <i className="ri-arrow-right-up-line"></i>
                      </Link>
                    </div>
                  </div>
                  <div
                    className={`lg:col-span-5 h-64 lg:h-auto min-h-[320px] ${
                      i % 2 === 1 ? "lg:order-first" : ""
                    }`}
                    style={{
                      backgroundImage: `url(${s.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                </article>
              </FadeUp>
            ))}
          </div>
        </section>

        {/* Find the Right Solution comparison */}
        <section className="bg-crest-deep py-20 md:py-24">
          <div className="px-6 md:px-12">
            <FadeUp className="max-w-2xl mb-10">
              <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-crest-orange uppercase">
                <span className="w-6 h-px bg-crest-orange/60" /> Find the right solution
              </span>
              <h2 className="font-display text-4xl md:text-5xl text-white leading-tight mt-5">
                Match your need to the right service.
              </h2>
            </FadeUp>
            <FadeUp delay={0.1}>
              <div className="bg-crest-bg/30 border border-white/10 rounded-xl overflow-hidden">
                <div className="hidden md:grid grid-cols-3 px-6 py-4 text-xs font-semibold tracking-wider uppercase text-crest-orange border-b border-white/10">
                  <div>Your Need</div>
                  <div>Best For</div>
                  <div>Primary Action</div>
                </div>
                <Stagger stagger={0.06}>
                  {comparison.map((c, i) => (
                    <StaggerItem
                      key={c.need}
                      className={`grid grid-cols-1 md:grid-cols-3 px-6 py-5 text-sm text-white gap-2 md:gap-0 ${
                        i !== comparison.length - 1 ? "border-b border-white/5" : ""
                      }`}
                    >
                      <div className="font-display text-base text-crest-orange">
                        {c.need}
                      </div>
                      <div className="text-white/80">{c.bestFor}</div>
                      <div className="text-white/75">{c.action}</div>
                    </StaggerItem>
                  ))}
                </Stagger>
              </div>
            </FadeUp>
          </div>
        </section>

        {/* CTA strip */}
        <section className="bg-crest-deep py-14 border-t border-white/5">
          <FadeUp>
            <div className="px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <h3 className="font-display text-2xl md:text-3xl text-white">
                  Not sure which service fits your requirement?
                </h3>
                <p className="text-white/65 mt-2 max-w-2xl">
                  Send us your elevator details and requirement. Our technical team can review and recommend the most suitable approach.
                </p>
              </div>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-crest-orange text-white px-7 py-3.5 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap hover:bg-crest-orangeLight transition-colors"
              >
                Talk to our technical team
                <i className="ri-arrow-right-up-line"></i>
              </Link>
            </div>
          </FadeUp>
        </section>
      </main>
      <Footer />
    </div>
  );
}